<template>
  <div>
    <Banner />
    <CoreTechnologies />
    <CoreCompetence />
    <DataCenter />
    <OwFooter />
  </div>
</template>
<script>
import Banner from "./components/banner";
import CoreTechnologies from "./components/coreTechnologies";
import CoreCompetence from "./components/coreCompetence";
import DataCenter from "./components/dataCenter";
import OwFooter from "@/components/ow-footer";
export default {
  name: "core-competence",
  components: {
    Banner,
    CoreTechnologies,
    CoreCompetence,
    DataCenter,
    OwFooter
  }
};
</script>
